import React from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  const handleProductClick = () => {
    navigate('/products'); // This assumes your products route is '/products'
  };

  return (
    <div className="products-container">
      <h1 className="products-title">Sản Phẩm Của Chúng Tôi</h1>
      
      <div className="products-grid">
        <div className="product-box" onClick={handleProductClick}>Long Định Bến Tre</div>
        <div className="product-box" onClick={handleProductClick}>Siêu</div>
        <div className="product-box" onClick={handleProductClick}>Quảng</div>
        <div className="product-box" onClick={handleProductClick}>Gạo Tròn</div>
        <div className="product-box" onClick={handleProductClick}>Q5</div>
        <div className="product-box" onClick={handleProductClick}>Hàm Châu</div>
        <div className="product-box" onClick={handleProductClick}>Khang Dân</div>
        <div className="product-box" onClick={handleProductClick}>Gạo 504</div>
        <div className="product-box" onClick={handleProductClick}>Gạo Ấn</div>
        <div className="product-box" onClick={handleProductClick}>Tấm Ấn</div>
        <div className="product-box" onClick={handleProductClick}>Tròn 202</div>
      </div>
    </div>
  );
}

export default Home; 